import React, { useEffect, useCallback, useState} from 'react';
import Annotation from '../links/Annotation.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {SEQUENCE_ANNOTATION} from 'constants/annotation-types.js';
import {useComments} from './useComments.js';
import PulseLoader from 'react-spinners/PulseLoader'
import ipfs from 'decentralized/Ipfs.js';
import ethereum from 'decentralized/ethereum.js';

const colors = new Colors();

const Comments = ({
    works,
    linkType=SEQUENCE_ANNOTATION,
}) => { 
    const {comments} = useComments({works, linkType});
    let style = {
    };

    comments.reverse();
    return (
        <div>
          {comments.map(
                a =>
                    <Annotation
                      style={style}
                      key={a.annotationData}
                      annotation={a}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
